export const getters = {
    getResponse(state) {
        return state.response;
    },
};

export default getters;
